import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { clearFormAdd, setDisponibildade, setListaScripts, toggleAddScript, triggerAgendarScript, triggerBaixaLog, triggerBaixarScript, triggerCarregaListaExecucoes, triggerCarregaListaScripts, triggerCarregaScriptAgendamentos, triggerDeletarScript, triggerFormAddProcessar, triggerFormEdicaoProcessar, triggerRemoverAgendamento, triggerSolicitaExecucao, triggerVerificaDisponibilidadeServidorRunner, updateAgendamentosAtributo, updateAgendamentosFormAtributo, updateExecucoesAtributo, updateFormAddAttr } from "./ScriptManagerSlice";
import axios from "axios";
import { server_runner_url, server_url } from '../core/config_geral'
import { isNotNull } from "../helper/functions";
import { generalErrorAction, publicarError } from "../helper/general-error/GeneralErrorSlice";


function* doVerificaDisponibilidade() {

    yield put(setDisponibildade("loading"))

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/scripts/ping-runner-execucao", {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => response)
        .catch(error => error))

    if (r.status == 200) {
        yield put(setDisponibildade(true))
    } else {
        yield put(setDisponibildade(false))
    }
}

function* doFormAddProcessar() {
    yield put(updateFormAddAttr({
        campo: "processando",
        value: true
    }))
    yield put(updateFormAddAttr({
        campo: "erro",
        value: ""
    }))

    var form = yield select((state) => state.scripts.formAdd)
    var token = yield select((state) => state.auth.token)

    var payload = {
        nome: form.nome,
        descricao: ""
    }

    var formData = new FormData()
    formData.append("file", form.arquivo)
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/scripts", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    yield put(updateFormAddAttr({
        campo: "processando",
        value: false
    }))


    if (r.status && (r.status == 200 || r.status == 201)) {
        yield put(clearFormAdd())
        yield put(triggerCarregaListaScripts())
    } else {
        yield put(publicarError(generalErrorAction(
            "ScriptsSaga.doFormAddProcessar",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
    }

}

function* doFormEdicaoProcessar() {

    yield put(updateFormAddAttr({
        campo: "processando",
        value: true
    }))
    yield put(updateFormAddAttr({
        campo: "erro",
        value: ""
    }))

    var form = yield select((state) => state.scripts.formAdd)
    var lista = yield select((state) => state.scripts.lista)
    var token = yield select((state) => state.auth.token)

    var script = lista.filter(e => e.id == form.edit)[0]
    var scriptId = form.edit

    var payload = {
        nome: form.nome
    }

    var formData = new FormData()

    var arquivo = typeof (form.arquivo) != "undefined" && form.arquivo != null && form.arquivo != false ? form.arquivo : null;
    formData.append("file", arquivo)
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.put(server_url + "/scripts/" + scriptId, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    yield put(updateFormAddAttr({
        campo: "processando",
        value: false
    }))

    if (r.status && (r.status == 200 || r.status == 201)) {
        yield put(clearFormAdd())
        yield put(triggerCarregaListaScripts())
    } else {
        yield put(publicarError(generalErrorAction(
            "ScriptsSaga.doFormEdicaoProcessar",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
    }
}

function* doCarregaListaScripts() {
    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/scripts",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.status && r.status === 200) {
        yield put(setListaScripts(r.data))
    } else {
        yield call(() => console.log(r))
    }

}

function* doDeletarScript(e) {

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.delete(server_url + "/scripts/" + e.payload,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.status && r.status === 200) {
        yield put(triggerCarregaListaScripts())
    } else {
        yield call(() => console.log(r))
    }
}

function* doCarregaListaExecucoes(action) {
    yield put(updateExecucoesAtributo({
        campo: "carregando",
        value: true
    }))

    yield put(updateExecucoesAtributo({
        campo: "lista",
        value: []
    }))

    var scriptId = action.payload

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/scripts/" + scriptId + "/execucoes",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.status && r.status === 200) {
        yield put(updateExecucoesAtributo({
            campo: "lista",
            value: r.data
        }))
    } else {
        yield call(() => console.log(r))
    }

    yield delay(1000)
    yield put(updateExecucoesAtributo({
        campo: "carregando",
        value: false
    }))

}

function* doSolicitaExecucao(action) {
 // Descontinuado

}

function* doBaixaLog(action) {
    var { scriptId, execucaoId } = action.payload

    yield put(updateExecucoesAtributo({
        campo: "modalOpen",
        value: true
    }))

    yield put(updateExecucoesAtributo({
        campo: "logData",
        value: null
    }))

    yield put(updateExecucoesAtributo({
        campo: "baixandoLog",
        value: true
    }))

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/scripts/" + scriptId + "/execucoes/" + execucaoId + "/log",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    // console.log(r.data)

    yield put(updateExecucoesAtributo({
        campo: "logData",
        value: r.data
    }))

    yield put(updateExecucoesAtributo({
        campo: "baixandoLog",
        value: false
    }))
}

function* doCarregaScriptAgendamentos() {

    yield put(updateAgendamentosAtributo({
        campo: "carregando",
        value: true
    }))

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/scripts/agendamentos",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    yield put(updateAgendamentosAtributo({
        campo: "lista",
        value: r.data
    }))

    yield put(updateAgendamentosAtributo({
        campo: "carregando",
        value: false
    }))



}

function* doRemoverAgendamento(action) {
    yield put(updateAgendamentosAtributo({
        campo: "carregando",
        value: true
    }))

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.delete(server_url + "/scripts/" + action.payload + "/agendamento",
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    yield put(triggerCarregaScriptAgendamentos())
}

function* doAgendarScript() {

    yield put(updateAgendamentosFormAtributo({
        campo: "erro",
        value: ""
    }))

    var form = yield select((state) => state.scripts.agendamentos.form)
    var scriptId = form.scriptId
    var periodicidade = form.periodicidade

    if (scriptId == null || scriptId == "") {

        yield put(updateAgendamentosFormAtributo({
            campo: "erro",
            value: "SCRIPT inválido"
        }))

        return
    }

    yield put(updateAgendamentosFormAtributo({
        campo: "processando",
        value: true
    }))

    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.post(server_url + "/scripts/" + scriptId + "/agendamento", {
        periodicidade: periodicidade
    },
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.status != 200) {
        if (typeof (r.response) != "undefined") {
            yield put(updateAgendamentosFormAtributo({
                campo: "erro",
                value: r.response.data.mensagem
            }))
        }
    } else {
        yield put(triggerCarregaScriptAgendamentos())
        yield put(updateAgendamentosFormAtributo({
            campo: "isOpen",
            value: false
        }))
    }

    yield put(updateAgendamentosFormAtributo({
        campo: "processando",
        value: false
    }))


}

function* doBaixarScript(action) {
    console.log(action)

    yield put(updateExecucoesAtributo({
        campo: "carregando",
        value: true
    }))

    var token = yield select((state) => state.auth.token)
    var formData = new FormData()

    var formToSend = {
        action: "SCPS_DOWNLOAD_BINARIO_RPC",
        runNow: true,
        payload: JSON.stringify({
            "scriptId": action.payload
        }),
    }

    console.log(formToSend)

    formData.append("file", null)
    formData.append("data",
        new Blob([JSON.stringify(formToSend)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        },
        responseType: "arraybuffer", // Importante para baixar binario
    }).then(response => response)
        .catch(error => error))

    var downloadFile = (content, fileName, fileType) => {

        // Create a Blob from the variable content
        var blob = new Blob([content], { type: fileType });

        // Create a Blob URL
        var blobUrl = URL.createObjectURL(blob);

        // Create an anchor element
        var a = document.createElement('a');

        // Set the anchor's href attribute to the Blob URL
        a.href = blobUrl;

        // Set the download attribute to the desired file name
        a.download = fileName;

        // Programmatically click the anchor element to trigger the download
        document.body.appendChild(a);
        a.click();

        // Remove the anchor element
        document.body.removeChild(a);

        // Revoke the Blob URL to free up resources
        URL.revokeObjectURL(blobUrl);
    }

    if (r.status && (r.status === 200 || r.status === 201)) {
        if (r.headers["content-type"] === "application/octet-stream") {
            // console.log(r)
            var d = r.data
            downloadFile(d, "binario.zip", r.headers["content-type"])
        }
    } else {
        yield put(publicarError(generalErrorAction(
            "RpcSaga.doSendRPCCall",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
    }

    yield put(updateExecucoesAtributo({
        campo: "carregando",
        value: false
    }))
}

export function* listenVerificaDisponibilidadeServidorRunner() {
    yield takeLatest(
        triggerVerificaDisponibilidadeServidorRunner, doVerificaDisponibilidade)
}

export function* listenFormAddProcessar() {
    yield takeLatest(triggerFormAddProcessar, doFormAddProcessar)
}

export function* listenFormEdicaoProcessar() {
    yield takeLatest(triggerFormEdicaoProcessar, doFormEdicaoProcessar)
}

export function* listenCarregaListaScripts() {
    yield takeLatest(triggerCarregaListaScripts, doCarregaListaScripts);
}

export function* listenDeletarScript() {
    yield takeLatest(triggerDeletarScript, doDeletarScript)
}

export function* listenCarregaListaExecucoes() {
    yield takeLatest(triggerCarregaListaExecucoes, doCarregaListaExecucoes)
}

export function* listenSolicitaExecucao() {
    yield takeLatest(triggerSolicitaExecucao, doSolicitaExecucao)
}

export function* listenCarregaScriptAgendamentos() {
    yield takeLatest(triggerCarregaScriptAgendamentos, doCarregaScriptAgendamentos)
}

export function* listenBaixaLog() {
    yield takeLatest(triggerBaixaLog, doBaixaLog);
}

export function* listenRemoverAgendamento() {
    yield takeLatest(triggerRemoverAgendamento, doRemoverAgendamento);
}

export function* listenAgendarScript() {
    yield takeLatest(triggerAgendarScript, doAgendarScript);
}

export function* listenTriggerBaixarScript() {
    yield takeLatest(triggerBaixarScript, doBaixarScript)
}